export default __webpack_public_path__ + "static/media/image-2.c9e0a39c.webp";